import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type SmartViewModalStore } from 'widgets/SmartViewModal'

type ISmartViewModalActionsProps = {
  store: SmartViewModalStore
}

export const SmartViewModalActions: FC<ISmartViewModalActionsProps> = observer(({ store }) => {
  const { titleButton, disabled, onSubmit, loadingSubmit } = store

  return (
    <Button
      text={titleButton}
      contained={'primary'}
      loading={loadingSubmit}
      disabled={disabled}
      onClick={onSubmit}
    />
  )
})
